import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PromoSignupStore {}

export enum PromoSignupStoreKeys {}
